export default "__VITE_ASSET__BdjAH6Km__"